import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

import { EstructuraBase } from '../model-form/estructura-base';
import { DropdownService } from '../servicios/dropdown.service';

import { MomentDateAdapter } from '@angular/material-moment-adapter';

import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

declare let $: any;

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'YYYY-MM-DD'
  }
};

@Component({
  selector: 'app-dynamic-report-contenido',
  templateUrl: './dynamic-report-contenido.component.html',
  styleUrls: ['./dynamic-report-contenido.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class DynamicReportContenidoComponent implements OnInit {
  @Input() item: EstructuraBase<any>;
  //@Input() destino:string;
  @Input() form: FormGroup;

  id: number;
  dataFiltered: any[];
  cargando = false;
  minDatePadre = new Date(2010, 1, 1);
  maxDatePadre = new Date(2020, 0, 1);
  minDateHijo = new Date(2010, 1, 1);
  maxDateHijo = new Date(2020, 0, 1);
  dateController1 = true;
  dateController2 = true;
  nombre = 'jose';

  constructor(private servicioCargaInformacion: DropdownService) {}

  ngOnInit() {}

  cargaDropDown(origenDatos, opt, label) {
    //alert(origenDatos);
    this.id = this.form.get(opt).value;
    //alert(origenDatos);
    //this.form.get(origenDatos)
    //alert(JSON.stringify(this.form.get(origenDatos)));
    this.cargando = true;
    this.servicioCargaInformacion.getData(origenDatos, this.id)
      .subscribe(data => {
        //this.dataFiltered=data;
        //alert(origenDatos);

        /*$("#" + origenDatos)
          .empty();*/
        $("#" + origenDatos).find('option').not(':first').remove();
        /*$("#" + origenDatos)
        .append('<option value="" disabled selected>' + label + '</option>');*/
        data.forEach(element => {
          $("#" + origenDatos)
            .append('<option value="' + element.id + '">' + element.valor + '</option>');
        });
        //$("#"+origenDatos+" option:eq(0)").attr("selected","selected");
        $("#" + origenDatos).val("");
        this.form.controls[origenDatos].setValue("");
        this.cargando = false;
        //$("#" + origenDatos).selectmenu().selectmenu('refresh', true);
      });
  }

  setValue(){

  }

  seleccionaFecha(event, tipo, elemento) {


    if (tipo == 'padre') {
      let fechaHijo = this.form.controls[elemento].value;
      let fechaPadre = event.value;
      if (fechaPadre > fechaHijo) {//SI LA FECHA INICIAL ES IGUAL
        this.form.controls[elemento].setValue(fechaPadre);
      }

      this.minDateHijo = new Date(2019, 1, 23);
      //alert(this.minDateHijo);
    }
    else if (tipo == 'hijo') {
      let fechaPadre = this.form.controls[elemento].value;
      let fechaHijo = event.value;


    }


  }

  padre(event, tipo, elemento) {
    //this.minDateHijo = new Date(2019, 1, 19);
    //this.minDatePadre = new Date(2019, 1, 15);
    //this.nombre="Pablo";
    //alert("aqui");
    /*setTimeout(function () {
      this.dateController2=true;
   }, 300);*/
   //alert(event.value);
   //event.stopPropagation();
    /*alert(event.value);
    alert(this.form.controls[elemento].value);
    let fechaPadre = _moment(event.value).format('YYYY-MM-DD');
    if(fechaPadre>this.form.controls[elemento].value){
      alert("fecha inicial mayor a fecha final");
    }*/

  }

  get isValid() { return this.form.controls[this.item.key].valid; }

  get Error() {
    // alert(this.form.controls[this.item.key].errors);
    return this.form.controls[this.item.key].errors;
  }
}
